// Lightweight first-party analytics — fires against /api/analytics/track.
// Failures are swallowed so the buyer flow never breaks.
import { api } from "./api";

const SESSION_KEY = "ao_session_id";

function getSessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export async function trackEvent(eventType, meta = {}) {
  try {
    await api.post("/analytics/track", {
      event_type: eventType,
      session_id: getSessionId(),
      referrer: document.referrer || null,
      path: window.location.pathname + window.location.search,
      ...meta,
    });
  } catch (_e) {
    // swallow — analytics failure should never affect the user
  }
}

export function trackPageView() {
  return trackEvent("page_view");
}

export function trackCta(location) {
  return trackEvent("cta_click", { location });
}
